export const homeURL = `${process.env.REACT_APP_HOME}`;
export const loginURL = `${process.env.REACT_APP_HOME}/user/login`;

//
export const adminRoot = "/app";

// direction
export const defaultDirection = "rtl"; // rtl or ltr

// language
export const defaultLanguage = "fa";

// sidebar
export const defaultSidebarState = 2; // 0 == both is close , 1 == main is open, 2 == both is open;
export const defaultSidebarMainWidth = 90; // in pixels
export const defaultSidebarSubWidth = 0; // in pixels
export const moveBoth = true; // false , true
export const mainMenuHasPage = true; // false , true --- by clicking on mainMenu items shows a new page or not

// header
export const defaultHeaderHeight = 60; // in pixels